import Markdown from 'markdown-it'

const md = Markdown({ breaks: true })

export const createMarkup = (markup) => ({ __html: md.render(markup) })
